import { RouterProvider } from "react-router";
import styles from "./App.module.css";
import { useRoleState } from "./lib/roleContext";
import router from "./lib/router";
import StyledError from "./modules/common/StyledError";
import Spinner from "./modules/common/Spinner";

const strings = {
  errorTitle: "Agent account failed to load",
  invalidErrorTitle: "Invalid User",
  invalidErrorMessage:
    "Notice: Invalid, Expired, or Disabled Fiserv User ID. Please reset or correct the issue and open Clarity again.",
};

export default function App() {
  const {
    roles,
    isLoadingRoles: isLoadingRoles,
    getRolesError: getRolesError,
    refetchRoles: refetchRoles,
  } = useRoleState();

  return isLoadingRoles ? (
    <div className={styles.container}>
      <Spinner />
    </div>
  ) : getRolesError ? (
    <div className={styles.container}>
      <StyledError
        error={getRolesError}
        errorTitle={strings.errorTitle}
        refetch={refetchRoles}
      />
    </div>
  ) : roles && !roles.isValid ? (
    <div className={styles.container}>
      <StyledError
        errorMessage={strings.invalidErrorMessage}
        errorTitle={strings.invalidErrorTitle}
        refetch={refetchRoles}
      />
    </div>
  ) : (
    <RouterProvider router={router} />
  );
}
